<div class="v-one-search">
  <v-one-input
    [formControl]="searchControl"
    [type]="'text'"
    [placeholder]="placeholder()"
    [leftIcon]="'search'"
  />
</div>
